import { Component, Inject, OnInit } from "@angular/core";
import {
  ComplaintDocumentVictimDetails,
  ComplaintPoADocumentResponse,
  IBackendClient,
  TermsOfServiceVariant,
} from "src/app/services/BackendClient";
import { UntilDestroy } from "@ngneat/until-destroy";
import { PolicyAcceptanceComponent } from "./policy-acceptance/policy-acceptance.component";
import { FormGroup } from "@angular/forms";
import { PoAGermanSwissComponent } from "../../../../../../../../shared/components/legal/poa/poa-swiss-german/PoA-german-swiss.component";
import { PoALGTComponent } from "../../../../../../../../shared/components/legal/poa/poa-lgt/PoA-LGT.component";
import { OpsDocHeaderComponent } from "../ops-doc-header/ops-doc-header.component";
import { PoAInternationalComponent } from "../../../../../../../../shared/components/legal/poa/poa-international/PoA-international.component";
import { PoAAustraliaComponent } from "../../../../../../../../shared/components/legal/poa/poa-australia/poa-australia.component";
import { PoAEuropeanInternationalComponent } from "../../../../../../../../shared/components/legal/poa/poa-european-international/PoA-european-international.component";
import {
  initializeReviewFormModel,
  ReviewFormModel,
} from "src/app/case-submission/models/review/review.form";
import { formatVictimName } from "../../../../../../../../shared/helpers/case-formatter";
import { OpsDocAuthTableComponent } from "../ops-doc-auth-table/ops-doc-auth-table.component";
import { ActivatedRoute } from "@angular/router";
import { BackendClientProvider } from "src/app/services/BackendClientProvider";
import { PoAFrenchSwissComponent } from "../../../../../../../../shared/components/legal/poa/poa-swiss-french/PoA-french-swiss.component";

@UntilDestroy()
@Component({
  selector: "ops-doc-poa-authorization",
  templateUrl: "./ops-doc-poa-authorization.component.html",
  styleUrls: ["./ops-doc-poa-authorization.component.scss"],
  imports: [
    PolicyAcceptanceComponent,
    PoAGermanSwissComponent,
    PoALGTComponent,
    OpsDocHeaderComponent,
    PoAInternationalComponent,
    PoAAustraliaComponent,
    PoAEuropeanInternationalComponent,
    OpsDocAuthTableComponent,
    PoAFrenchSwissComponent,
  ],
  standalone: true,
})
export class OpsDocPoaAuthorizationComponent implements OnInit {
  protected accessToken: string;
  protected poaDetails: ComplaintPoADocumentResponse;
  protected readonly TermsOfServiceVariant: typeof TermsOfServiceVariant = TermsOfServiceVariant;
  protected form: FormGroup<ReviewFormModel>;
  protected victimName: string;

  public constructor(
    private route: ActivatedRoute,
    @Inject(BackendClientProvider) private backendClient: IBackendClient,
  ) {
    this.accessToken = this.route.snapshot.paramMap.get("accessToken");
  }

  public ngOnInit() {
    this.getComplaintTermsOfServiceDetails();
    this.form = initializeReviewFormModel();
  }

  private getComplaintTermsOfServiceDetails() {
    this.backendClient.getComplaintPoADocumentDetails(this.accessToken).subscribe({
      next: (response) => {
        this.poaDetails = response;
        this.updateTermsOfService(response);
      },
    });
  }

  private updateTermsOfService(poaDetails: ComplaintPoADocumentResponse) {
    // The terms are all accepted, because the backend is not storing them correctly. Please change as soon as the backend
    // starts storing the terms correctly.
    this.form.patchValue({
      terms: {
        privacyPolicyAccepted: true,
        limitedAgencyAndReleaseAgreementAccepted: true,
        powerOfAttorneyAccepted: true,
        termsOfUseAccepted: true,
        digitalSignature: poaDetails.digitalSignature,
      },
      variant: poaDetails.variant,
    });
  }

  private setVictimName(victimDetails: ComplaintDocumentVictimDetails) {
    this.victimName = formatVictimName(
      victimDetails.victimCompany?.name,
      victimDetails.victimPerson?.firstName,
      victimDetails.victimPerson?.lastName,
      victimDetails.victimPerson?.companyName,
    );
  }
}
